import React from "react";
import { useTranslation } from "react-i18next";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";
import PartsModalSteps from "./PartsModalSteps";


type Props = {
  activeStep: number;
}

/**
 * オプション選択モーダルのステップ
 * 
 * @param props 
 * @returns 
 */
const PartsOptionModalSteps: React.FC<Props> = (props) => {

  const { t } = useTranslation();

  const steps = [
    {
      text: t("OptionSelectModal.プラン選択"),
      active: props.activeStep === 1 ? " active" : ""
    },
    {
      text: t("OptionSelectModal.詳細確認"),
      active: props.activeStep === 2 ? " active" : ""
    },
    {
      text: t("ComprehensiveOptionDetailsModal.日程選択"),
      active: props.activeStep === 3 ? " active" : ""
    },
    {
      text: t("OptionSelectModal.人数選択"),
      active: props.activeStep === 4 ? " active" : ""
    },
  ];

  return <PartsModalSteps steps={steps} activeStep={props.activeStep}/>
};

export default PartsOptionModalSteps;
